import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "projects/back-office/src/environments/environment";
import { Observable } from "rxjs";
import { AirNavPaymentProvider, AirNavPaymentProviderPostData } from "./air-nav-payment-provider";

@Injectable({ providedIn: 'root' })

export class AirNavPaymentProviderService {
    private http = inject(HttpClient);

    private baseUrl = '/anpp';
    private airNavPaymentProvidersUrl = `${environment.backendServer}${this.baseUrl}`;
    private dashboardUrl = `${environment.backendServer}/dashboard${this.baseUrl}`;

    getAirNavPaymentProviders(options?: HttpParams): Observable<AirNavPaymentProvider[]> {
        return this.http.get<AirNavPaymentProvider[]>(this.airNavPaymentProvidersUrl, { params: options });
    }

    createAirNavPaymentProvider(data: AirNavPaymentProviderPostData): Observable<AirNavPaymentProvider> {
        return this.http.post<AirNavPaymentProvider>(this.airNavPaymentProvidersUrl, data);
    }

    getAirNavPaymentProviderById(id: string): Observable<AirNavPaymentProvider> {
        return this.http.get<AirNavPaymentProvider>(`${this.airNavPaymentProvidersUrl}/${id}`);
    }

    updateAirNavPaymentProvider(id: string, data: AirNavPaymentProvider): Observable<AirNavPaymentProvider> {
        return this.http.put<AirNavPaymentProvider>(`${this.airNavPaymentProvidersUrl}/${id}`, data);
    }

    deleteAirNavPaymentProvider(id: string): Observable<any> {
        return this.http.delete<any>(`${this.airNavPaymentProvidersUrl}/${id}`);
    }

    getDashboardAirNavPaymentProviders(options?: HttpParams): Observable<AirNavPaymentProvider[]> {
        return this.http.get<AirNavPaymentProvider[]>(this.dashboardUrl, { params: options });
    }

    approveAirNavPaymentProvider(id: string, data: any): Observable<AirNavPaymentProvider> {
        return this.http.put<AirNavPaymentProvider>(`${this.airNavPaymentProvidersUrl}/${id}/approve`, data);
    }

    rejectAirNavPaymentProvider(id: string, data: any): Observable<AirNavPaymentProvider> {
        return this.http.put<AirNavPaymentProvider>(`${this.airNavPaymentProvidersUrl}/${id}/reject`, data);
    }
}
